import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Hero,
  ExtendedBox,
  UnlockOpportunities,
  ScrollToTopOnMount,
} from '../coreui';

import DynamicBrowseJoinLink from '../helpers';
import SubNav from '../components/subNav';

import Reits from './components/reits';
import MeetReits from './components/meetReits';
import PrivatePlacement from './components/pp';
import Strategy from './components/strategy';
import Section from '../ioDetails/components/section';
import Overview from './components/overview';
import RecentInvestments from '../homepage/recentInvestments';
import ScrollToHash from '../components/ScrollToHash';

import heroBannerImage from '../assets/Img_hero_investOpts.jpg';
import data from './data';

class InvestmentOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { title: 'Overview', name: 'overview' },
        { title: 'REITs', name: 'reits' },
        { title: 'Individual Properties', name: 'pp' },
        { title: '1031 Exchange', name: 'exchange' },
      ],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {
      user,
      reitData,
    } = this.props;

    const isLoggedIn = user.isLoggedIn;

    const BrowseLink = () => {
      return (
        <ExtendedBox
          textAlign="center"
          mx="auto"
          mt={[25, 50, 75, 100, 100]}
        >
          <DynamicBrowseJoinLink
            isLoggedIn={isLoggedIn}
            anonText="Get Started"
            type="L1"
          />
        </ExtendedBox>
      );
    };

    return (
      <React.Fragment>
        <ScrollToTopOnMount />
        <SubNav
          items={this.state.navItems}
        />
        <Hero
          image={heroBannerImage}
          header={data.hero.header}
          subHeader={data.hero.subheader}
        />
        <Section
          title={data.overview.title}
          bg="gray.0"
          name="overview"
        >
          <Overview
            title={null}
            subtitle={data.overview.subtitle}
            items={data.tools}
          />
          <BrowseLink />
        </Section>
        <a name="reits" />
        <ScrollToHash name="reits" />
        <Reits />
        <Section
          title={data.meet.title}
          bg="gray.0"
        >
          <MeetReits
            body={data.meet.body}
            bottomText={data.meet.bottom}
            investments={reitData}
          />
        </Section>
        <a name="pp" />
        <ScrollToHash name="pp" />
        <PrivatePlacement />
        <RecentInvestments
          isLoggedIn={isLoggedIn}
          title="Recent Individual Properties"
          subtitle="A SAMPLE OF THE INVESTMENTS WE’VE MADE"
          smartBtn
        />
        <a name="exchange" />
        <ScrollToHash name="exchange" />
        <Strategy
          isLoggedIn={isLoggedIn}
        />
        <UnlockOpportunities
          isLoggedIn={isLoggedIn}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.app.user,
  reitData: state.reitData.list,
});

InvestmentOptions.propTypes = {
  user: PropTypes.object,
  reitData: PropTypes.array,
};

export default connect(mapStateToProps)(InvestmentOptions);
